import { useI18n, SUPPORTED_LANGUAGES } from '../i18n'
import BrandLogo from './BrandLogo'
import type { SupportedLanguage } from '../i18n'

const LANG_LABELS: Record<SupportedLanguage, string> = {
  de: 'DE', en: 'EN', sl: 'SL', it: 'IT', es: 'ES',
}

export default function SiteFooter() {
  const { t, lang, setLang } = useI18n()

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">

        {/* Brand + Description */}
        <div className="site-footer__brand">
          <div className="site-footer__logo">
            <BrandLogo mark="inline" size={30} nameClassName="site-footer__brand-name" style={{ gap: 'inherit' }} />
          </div>
          <p className="site-footer__tagline">
            {t.footer.tagline}
          </p>
        </div>

        {/* Links */}
        <div className="site-footer__links">
          <div className="site-footer__col">
            <span className="site-footer__col-title">{t.footer.legal.title}</span>
            <a href="/impressum" className="site-footer__link">{t.footer.legal.imprint}</a>
            <a href="/datenschutz" className="site-footer__link">{t.footer.legal.privacy}</a>
            <a href="/agb" className="site-footer__link">{t.footer.legal.terms}</a>
          </div>
          <div className="site-footer__col">
            <span className="site-footer__col-title">{t.footer.contact}</span>
            <a href="mailto:office@arkturian.com" className="site-footer__link">office@arkturian.com</a>
            <span className="site-footer__text">Makerspace Carinthia</span>
            <span className="site-footer__text">Lastenstraße 26, 9020 Klagenfurt</span>
          </div>
          <div className="site-footer__col">
            <span className="site-footer__col-title">{t.footer.more.title}</span>
            <a href="/" className="site-footer__link">{t.footer.more.floraFauna}</a>
            <a href="/styleguide" className="site-footer__link">Styleguide</a>
          </div>
        </div>

        {/* Divider */}
        <div className="site-footer__divider" />

        {/* Sponsor Logos + Copyright */}
        <div className="site-footer__bottom">
          <div className="site-footer__sponsors">
            <span className="site-footer__sponsor-label">{t.footer.sponsoredBy}</span>
            <div className="site-footer__sponsor-logos">
              <img src="/logo-kwf.png" alt="Kärntner Wirtschaftsförderungs Fonds" className="site-footer__sponsor-img" />
              <img src="/logo-fh.png" alt="FH Kärnten" className="site-footer__sponsor-img" />
              <img src="/logo-makerspace.webp" alt="Makerspace Carinthia" className="site-footer__sponsor-img" />
            </div>
          </div>
          <div className="site-footer__bottom-right">
            <div className="site-footer__lang">
              {SUPPORTED_LANGUAGES.map(l => (
                <button
                  key={l}
                  className={`site-footer__lang-btn${l === lang ? ' site-footer__lang-btn--active' : ''}`}
                  onClick={() => setLang(l)}
                >
                  {LANG_LABELS[l]}
                </button>
              ))}
            </div>
            <span className="site-footer__copy">{t.footer.copyright(new Date().getFullYear())}</span>
          </div>
        </div>

      </div>
    </footer>
  )
}
